module.exports = __webpack_public_path__ + "img/Medical_Case_pic03.23b36b6b.jpg";